export enum OrderActionEnum {
  Request = 1,
  Order = 10,
  Measurement = 20,
  Monitoring = 30,
  Monolith = 35,
  Installation = 40,
  Completion = 50,
}
